import React, { useEffect } from "react";

function WhatsappGroupRedirect() {
  useEffect(() => {
    // Replace with your target URL
    window.location.href = "https://meet.google.com/vtz-smqt-tgi";
  }, []);

  return (
    <section className="text-gray-600 body-font relative">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-col text-center w-full mb-12">
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
            Redirecting to class.. Direct link :{" "}
            <a href="https://meet.google.com/vtz-smqt-tgi">Link</a>
          </p>
        </div>
      </div>
    </section>
  );
}

export default WhatsappGroupRedirect;
